<template>
  <b-container fluid>
    <b-row style="margin-bottom: 5px;">
      <b-col cols="auto">
        市場作物名稱:
      </b-col>
      <b-col v-if="chart.croplist.options.length > 0" cols="10">
        <v-select
          style="min-width:fit-content; width: 17vh; display: inline-grid; margin-right: 10px;"
          v-model="chart.croplist.value"
          :options="chart.croplist.options"
          :selectable="(car) => car.disabled"
        ></v-select>
      </b-col>
      <b-col v-else>
        <b-spinner
          style="width: 1.5rem; height: 1.5rem;"
          variant="success"
          label="Spinning"
        />
      </b-col>
    </b-row>
    <div style="margin-top: 1rem;" v-if="chart.ifshow">
      <!-- <b-overlay :show="chart.ifloading" rounded="sm"> -->
      <template v-if="!chart.ifloading">
        <!-- <span
          style="width: 40vw; display: inline-block; margin-right: 2rem; overflow-x: scroll;"
        >
          <apexchart
            ref="chart1ref"
            type="donut"
            :options="chart.donut.options"
            :series="chart.donut.series"
          ></apexchart>
        </span>
        <span style="width: 40vw;display: inline-block; overflow-x: scroll;">
          <apexchart
            ref="chart2ref"
            type="line"
            :options="chart.line.options"
            :series="chart.line.series"
          ></apexchart>
        </span> -->
        <b-container fluid>
          <b-row>
            <b-col class="chartdiv" lg="5" md="12">
              <apexchart
                ref="chart1ref"
                type="donut"
                :options="chart.donut.options"
                :series="chart.donut.series"
              ></apexchart>
            </b-col>
            <b-col class="chartdiv" lg="6" md="12">
              <apexchart
                ref="chart2ref"
                type="line"
                :options="chart.line.options"
                :series="chart.line.series"
              ></apexchart>
            </b-col>
          </b-row>
        </b-container>
      </template>
      <template v-else>
        <b-spinner
          style="width: 1.5rem; height: 1.5rem;"
          variant="success"
          label="Spinning"
        />
      </template>
      <!-- </b-overlay> -->
    </div>
  </b-container>
</template>

<script>
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const nowyear = today.getFullYear() - 1911
  const fiveyearsago = today.setFullYear(today.getFullYear() - 5)
  const oldyear = new Date(fiveyearsago).getFullYear() - 1911
  let yeartext = oldyear + '-' + nowyear + '年';
export default {
  data() {
    return {
      chartwidth: "100%",
      window: {
        width: 1024,
        height: 0,
      },
      chart: {
        ifshow: false,
        ifloading: false,
        croplist: {
          items: [],
          value: { label: "請選擇", code: "請選擇", disabled: false },
          options: [],
        },
        donut: {
          series: [],
          options: {
            chart: {
              type: "donut",
              width: "100%",
              zoom: {
                enabled: false,
              },
            },
            title: {
              text: yeartext + "月均交易量(公噸)變化",
            },
            labels: [
              "一月",
              "二月",
              "三月",
              "四月",
              "五月",
              "六月",
              "七月",
              "八月",
              "九月",
              "十月",
              "十一月",
              "十二月",
            ],
            colors: [
              "#D8232A",
              "#DC3E3D",
              "#E7792B",
              "#ED9F2D",
              "#FFF101",
              "#6CB644",
              "#009956",
              "#00A09B",
              "#005C9C",
              "#233881",
              "#4E2B79",
              "#922A7D",
            ],
            responsive: [
              {
                breakpoint: 550,
                options: {
                  chart: {
                    width: 550,
                  },
                  legend: {
                    position: "bottom",
                  },
                },
              },
            ],
          },
        },
        line: {
          series: [],
          options: {
            chart: {
              type: "line",
              width: 550,
              zoom: {
                enabled: false,
              },
            },
            title: {
              text: yeartext + "與今年月均交易量(公噸)變化",
            },
            dataLabels: {
              enabled: true,
            },
            noData: {
              text: "目前無資料",
              align: "center",
              verticalAlign: "middle",
            },
            labels: [
              "一月",
              "二月",
              "三月",
              "四月",
              "五月",
              "六月",
              "七月",
              "八月",
              "九月",
              "十月",
              "十一月",
              "十二月",
            ],
            responsive: [
              {
                breakpoint: 550,
                options: {
                  chart: {
                    width: 550,
                  },
                  legend: {
                    position: "bottom",
                  },
                },
              },
            ],
          },
        },
        fiveyearslist: [],
        lastyearlist: [],
        thisyearlist: [],
        counter: 0,
      },
      apiGetMainCropList: (data) =>
        this.userRequest.post("/API/Default/getMainCropList", data),
      apiGetTradeAvg5Year: (data) =>
        this.userRequest.post("/API/Default/getTradeAvg5Year", data),
      apiGetTradeAvgLastYear: (data) =>
        this.userRequest.post("/API/Default/getTradeAvgLastYear", data),
      apiGetTradeAvgThisYear: (data) =>
        this.userRequest.post("/API/Default/getTradeAvgThisYear", data),
    };
  },
  created() {
    this.init();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    init() {
      window.addEventListener("resize", this.handleResize);
      this.handleResize();
      this.FunctionToken(this.getMainCropList, {});
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      this.chart.line.options.chart.width =
        this.window.width > 550 ? "100%" : 550;
    },
    getMainCropList(data) {
      this.apiGetMainCropList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.chart.croplist.options = [];
            let arr = JSON.parse(json.Data);
            arr.forEach((x) => {
              let obj = {
                label: x.V_NAME,
                code: x.CROP_CODE,
                disabled: true,
              };
              this.chart.croplist.options.push(obj);
            });
            this.chart.croplist.options.unshift({
              label: "請選擇",
              code: "請選擇",
              disabled: false,
            });
          }
        })
        .catch((err) => console.warn(err));
    },
    getTradeAvg5Year(data) {
      this.apiGetTradeAvg5Year(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.chart.fiveyearslist = JSON.parse(json.Data);
            this.chart.counter++;
            this.checkfinish();
          }
        })
        .catch((err) => console.warn(err));
    },
    getTradeAvgLastYear(data) {
      this.apiGetTradeAvgLastYear(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.chart.lastyearlist = JSON.parse(json.Data);
            this.chart.counter++;
            this.checkfinish();
          }
        })
        .catch((err) => console.warn(err));
    },
    getTradeAvgThisYear(data) {
      this.apiGetTradeAvgThisYear(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.chart.thisyearlist = JSON.parse(json.Data);
            this.chart.counter++;
            this.checkfinish();
          }
        })
        .catch((err) => console.warn(err));
    },
    getalldata(value) {
      this.chart.counter = 0;
      this.chart.ifshow = true;
      this.chart.ifloading = true;
      let obj = {
        CROP_CODE: value,
      };
      this.FunctionToken(this.getTradeAvg5Year, obj);
      this.FunctionToken(this.getTradeAvgLastYear, obj);
      this.FunctionToken(this.getTradeAvgThisYear, obj);
    },
    checkfinish() {
      if (
        this.chart.counter == 3 &&
        this.chart.fiveyearslist.length != 0 &&
        this.chart.thisyearlist.length != 0 &&
        this.chart.lastyearlist.length != 0
      )
        this.createchart();
    },
    createchart() {
      let chart1list = [],
        chart2list = [],
        chart3list = [],
        chart4list = [];
      this.chart.fiveyearslist.forEach((x) => {
        chart1list.push(x.AVERAGE_VOLUME);
        chart4list.push(Number.parseFloat(x.AVERAGE_VOLUME).toFixed(2));
      });
      this.chart.lastyearlist.forEach((x) =>
        chart2list.push(Number.parseFloat(x.AVERAGE_VOLUME).toFixed(2))
      );
      this.chart.thisyearlist.forEach((x) =>
        chart3list.push(Number.parseFloat(x.AVERAGE_VOLUME).toFixed(2))
      );
      // if (chart3list.length < 12) {
      //   let num = 12 - chart3list.length;
      //   for (let i = 0; i < num; i++) {
      //     chart3list.push(null);
      //   }
      // }
      // let count = 0,
      //   colorlist = [];
      // while (count < 13) {
      //   let str = this.changeColor();
      //   if (colorlist.indexOf(str) == -1) {
      //     colorlist.push(str);
      //     count++;
      //   }
      // }

      this.chart.donut.series = [];
      this.chart.donut.series = chart1list;

      this.chart.line.series = [];
      this.chart.line.series.push({
        name: yeartext + "均交易量",
        type: "line",
        data: chart4list,
      });
      this.chart.line.series.push({
        name: "去年均交易量",
        type: "line",
        data: chart2list,
      });
      this.chart.line.series.push({
        name: "今年均交易量",
        type: "line",
        data: chart3list,
      });
      this.chart.ifloading = false;
      this.$nextTick(() => {
        this.$refs.chart1ref.updateSeries(this.chart.donut.series);
        this.$refs.chart2ref.updateSeries(this.chart.line.series);
        this.$forceUpdate();
      });
    },
    changeColor() {
      var colorStr = "";
      var randomArr = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
      ];
      for (let i = 0; i < 6; i++) {
        colorStr += randomArr[Math.ceil(Math.random() * (15 - 0), 0)];
      }
      return "#" + colorStr;
    },
  },
  watch: {
    "chart.croplist.value"(val) {
      this.getalldata(val.code);
    },
  },
};
</script>

<style scoped>
  .charttest {}
</style>
